import React, { useEffect, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectQuotView } from '../../Selectors/Master/ItemSelectors';
import { fetchQuotViewlist, updateQuotationRate } from '../../../Store/PHPSlice/Sale/Quotation';
import { Grid, Paper } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import CircularProgress from '@mui/material/CircularProgress';


const RateChange = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: '',
        quotNo: '',
        itemNm: '',
        firmNm: '',
        priceNm: '',
        partyNm: '',
        schlNm: '',
        jobrate: '',
        outSrc: '',
        extra: '',
        mcloth: '',
        mrate: '',
        mpanna: '',
        m1cloth: '',
        m1rate: '',
        m1panna: '',
        m2cloth: '',
        m2rate: '',
        m2panna: '',
        m3cloth: '',
        m3rate: '',
        m3panna: '',
        userId: userdata?.ID
    });
    const { Id } = useParams();
    const [newRates, setNewRates] = useState([]);
    const [itemData, setItemData] = useState([]);

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const viewlist = useSelector(selectQuotView);
    const isDesktop = useMediaQuery('(min-width:768px)');
    useEffect(() => {
        dispatch(fetchQuotViewlist(Id))
    }, [Id]);
    useEffect(() => {
        if (viewlist.data && viewlist.data.length > 0) {
            const item = viewlist.data[0];
            setFormData(prev => ({
                ...prev,
                dt: item.dt || '',
                quotNo: item.quotNo || '',
                itemNm: item.itemNm || '',
                firmNm: item.firmNm || '',
                priceNm: item.grpNm || '',
                partyNm: item.partyNm || '',
                schlNm: item.schoolNm || '',
                jobrate: item.jobrate || '',
                outSrc: item.outSrc || '',
                extra: item.extra || '',
                mcloth: item.clothNm || '',
                mrate: item.rate || '',
                mpanna: item.panna || '',
                m1cloth: item.m1cloth || '',
                m1rate: item.m1rate || '',
                m1panna: item.m1panna || '',
                m2cloth: item.m2cloth || '',
                m2rate: item.m2rate || '',
                m2panna: item.m2panna || '',
                m3cloth: item.m3cloth || '',
                m3rate: item.m3rate || '',
                m3panna: item.m3panna || '',
            }));
        }
    }, [viewlist]);

    useEffect(() => {
        if (viewlist?.avgs?.length > 0) {
            const data = {
                size: viewlist.avgs.map(val => val.size),
                rate: viewlist.avgs.map(val => parseFloat(val.rate)),
                newRate: Array(viewlist?.avgs?.length).fill('0')
            };
            setItemData(data);
        }
    }, [viewlist]);
    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '70%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    // var itemData = viewlist.avgs.length > 0 ? {
    //     size: viewlist.avgs.map(val => val.size),
    //     rate: viewlist.avgs.map(val => parseFloat(val.rate)),
    //     newRate: Array(viewlist?.avgs?.length).fill('0')
    // } : [];

    const handleRateChange = (index, value) => {
        // Allow only numeric input
        if (!/^\d*$/.test(value)) {
            return;
        }

        setNewRates(prev => {
            const updatedRates = [...prev];
            updatedRates[index] = value;
            return updatedRates;
        });

        setItemData(prevData => {
            const updatedRates = [...prevData.newRate];
            updatedRates[index] = value;

            return {
                ...prevData,
                newRate: updatedRates
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            const finalObject = {
                size: itemData?.size,
                quotId: Id,
                // rate: newRates,
                rate: itemData?.newRate,
                userId: formData.userId
            };
            // console.log(finalObject);

            const result = await dispatch(updateQuotationRate(finalObject)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Quotation Updated");
            alert("Quotation Updated");
            window.close();

        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }


    }
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }}>

                        <h3 className='centered-heading'>Rate Change</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>

                            <tbody>

                                <tr>
                                    <td style={{ width: '200px' }}>Party</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.partyNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>
                                    <td>:</td>
                                    <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{formData.dt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>School</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.schlNm}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Item</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0 1.5%' }}>{formData.itemNm}</td>

                                </tr>
                            </tbody>

                        </table>


                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>MIL To Party</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>New Rate</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>


                                    {itemData.size ? itemData.size.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item}</TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{itemData.rate[index]}</TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                <input
                                                    type="text"
                                                    name='newRates'
                                                    // value={newRates[index] || ''}
                                                    value={itemData.newRate[index]}
                                                    onChange={(e) => handleRateChange(index, e.target.value)}
                                                    style={{ width: '200px', padding: '5px' }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )) : ''}

                                </TableBody>
                            </Table>
                        </TableContainer>

                        <div style={{ margin: '2% 5%' }}>
                            <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                {
                                    loading === true ?
                                        <><CircularProgress size="20px" style={{ color: 'white' }} /> wait...</> :
                                        "Submit"
                                }
                            </Button>
                        </div>
                    </div>
                    <ToastContainer />
                </Paper>
            </Grid>
        </>
    );
};

export default RateChange;
